import axios from "axios";

export const getFixerRates = async (symbolsString: string) => {
  return await axios.get(
    `${process.env.REACT_APP_FIXER_ID}/api/latest?access_key=${process.env.REACT_APP_ACCESS_KEY}&base=INR&symbols=${symbolsString}`,
  );
};
